export const BACKEND_API = `https://api.kelvin-checo.dev/${process.env.REACT_APP_ENV == 'production' ? 'v1' : 'dev'}`;